<ng-container *transloco="let convert;">
  @if (isVisible) {
    <div class="purchase-history">
      <div class="purchase-history__content">
        <header>
          <h3 class="text-brand fw-normal" tabindex="-1" #heading>{{convert('sellModule.manageInventory.purchaseHistory.textHistory')}}</h3>
        </header>
        <div class="purchase-details">
          <div class="purchase-details__item">
            <div class="purchase-details__item-label">{{purchaseHistoryTranslations.textVIN}}</div>
            <div [id]="'purchase-details_history_vin_' + auctionItemUuid" class="purchase-details__item-value">
              {{ vehicleVin }}
            </div>
          </div>
          <div class="purchase-details__item ps-3 ps-sm-0">
            <div class="purchase-details__item-label">{{convert('sellModule.manageInventory.purchaseHistory.textWinningAmount')}}</div>
            <div [id]="'purchase-details_history_sale_price_' + auctionItemUuid" class="purchase-details__item-value">
              {{ formatCurrency(salePrice) }}
            </div>
          </div>
          <div class="purchase-details__item">
            <div class="purchase-details__item-label">{{convert('sellModule.manageInventory.purchaseHistory.textDate')}}</div>
            <div [id]="'purchase-details_history_sale_date_' + auctionItemUuid" class="purchase-details__item-value">
              {{ saleDate }}
            </div>
          </div>
        </div>
        @if (purchaseOfferHistory) {
          <div class="purchase-by-date" [ngClass]="historyCount > 3 ? 'has-scroll' : ''" tabindex="0">
            @for (date of purchaseOfferHistory.dates; track date; let i = $index) {
              <div class="purchase-by-date__date">
                <span [id]="'purchase_details_history_transaction_date_' + i" class="purchase-by-date__date-text">{{
                  localizeDate(date)
                }}</span>
              </div>
              @for (transaction of purchaseOfferHistory.purchaseByDate[date]; track transaction; let even = $even; let prevIndex = $index) {
                <div
                  class="purchase-by-date--details"
                  [ngClass]="even && historyCount > 1 ? 'row-even' : 'row-odd'"
                  >
                  <div class="row space-between py-1">
                    @if (!systemTransaction(transaction)) {
                      <p [id]="'offer_details_history_role_' + i + prevIndex" class="bold">
                        @if (transaction.role !== 'SELLER') {
                          {{ transaction.oeName }}
                        }
                        @if (transaction.role === 'SELLER') {
                          <ng-container [ngTemplateOutlet]="transactionUserName" [ngTemplateOutletContext]="{$implicit:transaction}"></ng-container>
                        }
                      </p>
                    }
                    @if (systemTransaction(transaction)) {
                      <p [id]="'offer_details_history_role_' + i + prevIndex" class="bold">{{convert('sellModule.manageInventory.purchaseHistory.textSystem')}}</p>
                    }
                    <p>{{ formatTime(transaction.date) }} </p>
                  </div>
                  <p [id]="'offer_details_history_status_' + i + prevIndex" class="py-1">
                    <span class="bold">{{convert('sellModule.manageInventory.purchaseHistory.textAmount')}}</span> {{ formatCurrency(transaction.amount) }}
                  </p>
                  <p [id]="'offer_details_history_amount_' + i + prevIndex" class="py-1">
                    <span class="bold">{{convert('sellModule.manageInventory.purchaseHistory.textTransactionType')}}</span>
                    {{ convert(transaction.type | purchaseStatus) }}
                  </p>
                  <p [id]="'offer_details_history_comments_' + i + prevIndex" class="py-1 d-flex">
                    <span class="bold fw-bold">{{convert('sellModule.manageInventory.purchaseHistory.textComments')}} </span>
                    <span class="comments-value ps-1">{{ comment(transaction)}}</span>
                  </p>
                </div>
              }
            }
          </div>
          <div class="offer-history__footer d-none d-lg-block" [ngClass]="historyCount > 3 ? 'has-scroll' : ''"></div>
          <div class="offer-history__footer-mobile d-flex flex-column d-lg-none">
            <button
              class="btn btn-primary"
              type="submit"
              data-track-elem="button"
              data-track-name="Close History"
              (click)="closeHistory()"
              >
              {{convert('common.btnClose')}}
            </button>
          </div>
        }
      </div>
      <div class="history__close">
        <button
          class="history__close__button"
          [attr.aria-label]="convert('common.ariaLabelCloseHistory')"
          data-track-elem="icon"
          data-track-name="Close"
          data-track-trigger="close"
          (click)="closeHistory()"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  }

  <ng-template #transactionUserName let-transaction>
    @if (getTransactionUserName(transaction).length > 0) {
      {{convert('sellModule.manageInventory.purchaseHistory.textSeller')}}
      @if (isMobile && getTransactionUserName(transaction).length >= 14) {
        <app-tooltip
          [tooltip]="{ body: getTransactionUserName(transaction) }"
          triggers="click hover :keydown.escape :keydown.tab">
          <span [attr.aria-label]="getTransactionUserName(transaction)">{{ getTransactionUserName(transaction).substr(0, 14).trim() + '...' }}</span>
        </app-tooltip>
      }
      @if (!isMobile && getTransactionUserName(transaction).length >= 32) {
        <app-tooltip
          [tooltip]="{ body: getTransactionUserName(transaction) }"
          triggers="click hover :keydown.escape :keydown.tab">
          <span [attr.aria-label]="getTransactionUserName(transaction)">{{ getTransactionUserName(transaction).substr(0, 32).trim() + '...' }}</span>
        </app-tooltip>
      }
      @if ((isMobile && getTransactionUserName(transaction).length < 14) || (!isMobile && getTransactionUserName(transaction).length < 32)) {
        {{ getTransactionUserName(transaction)}}
      }
    }
  </ng-template>
</ng-container>
